import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    cif: { label: i18n.t('companies.cif'), value: '' },
    name: { label: i18n.t('companies.companyName'), value: '' },
    send_alerts: { label: i18n.t('app.send_alerts'), value: '' },
    fechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '', type: 'date' },
    fechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '', type: 'date' },
    activo: { label: i18n.t('app.active'), value: '' },
    email: { label: i18n.tc('users.email', 1), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
    distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
    certAsociado: { label: i18n.t('companies.cert_asociado'), value: '' },
    nombreAgrupacion: { label: i18n.t('grouping.entity_name'), value: '' },
  }
}
const getColumns = function getColumns () {
  return [
    { field: 'IdCIFEmpresa', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      },
    },
    {
      field: 'Cliente',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      width: '150px',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'RazonSocial', width: '160px', title: i18n.t('companies.companyName'), columnMenu: 'myTemplate', locked: false },
    { field: 'CIF', width: '130px', title: i18n.t('companies.cif'), columnMenu: 'myTemplate', locked: false },
    {
      field: 'Activo',
      width: '130px',
      title: i18n.t('app.active'),
      cell: 'checkboxTemplate',
      columnMenu: 'myTemplate',
      locked: false,
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active'), },
    },
    { field: 'FechaAlta', title: i18n.t('app.created_at'), type: 'date', filter: 'date', format: 'numeric_datetime', cell: 'fechaTemplate', columnMenu: 'myTemplate', width: '155px', locked: false, extraparams: { separators: { date: '-', datetime: ' ' } } },
    { field: 'EnviarAvisos', width: '150px', title: i18n.t('app.send_alerts'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'certAsociado', width: '200px', title: i18n.t('companies.cert_asociado'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'EmailAvisoNuevaEmitida', title: i18n.t('companies.email_nueva_emitida'), hidden: true, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoNuevaRecibida', title: i18n.t('companies.email_nueva_recibida'), hidden: true, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailAvisoCambioEstado', title: i18n.t('companies.email_cambio_estado'), hidden: true, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'EmailTecnico', title: i18n.t('companies.email_tech'), hidden: true, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'Direccion', title: i18n.t('address.location'), hidden: true, columnMenu: 'myTemplate', width: '350px', locked: false },
    { field: 'CodigoPostal', title: i18n.t('address.codigo_postal'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
    { field: 'Poblacion', title: i18n.t('address.poblacion'), hidden: true, columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'Provincia', title: i18n.t('address.provincia'), hidden: true, columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'CodigoPais', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', hidden: true, columnMenu: 'myTemplate', width: '250px', locked: false },
    { field: 'Telefono', title: i18n.t('address.telefono'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
    { field: 'Agrupaciones', width: '440px', title: i18n.t('grouping.header'), columnMenu: 'myTemplate', locked: false, cell: 'tagsTemplate', type: 'boolean', sortable: false, groupable: false },  
    {
      field: 'idCliente',
      title: i18n.t('clients.id_client'),
      hidden: true,
      columnMenu: 'myTemplate',
      width: '150px',
      locked: false,
      only: {
        roles: [7, 8, 3],
      }, 
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
